import { render } from "./App.vue?vue&type=template&id=a2bb6ab0"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import "./App.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__